import GlobalVariables from '../GlobalVariables';

const languageTransferRequest = function (baseUrl, ajax, chatId, lng) {
    if (ApexChat.options.aiBotEnabled) {
        ajax({
            url: `${GlobalVariables.LiveChatServiceUrl}Services/ApexChatUtilityService.svc/chats/${chatId}/${lng}/chat-bot-language-transfer`,
            type: 'GET'
        });
        return;
    }
    ajax({
        url: `${GlobalVariables.LiveChatServiceUrl}Services/ApexChatUtilityService.svc/chats/${chatId}/${lng}/transfer`,
        type: 'GET'
    });
};
export default languageTransferRequest;
